/**
 * @name SalesReportService
 * @author Surjeet Bhadauriya <surjeet.bhadauriya@techifysolutions.com>
 * @description All APIs for sales report
 * @version 0.0.0
 */

import { request } from "./Request";
import { routes } from "../constants/constant.route";

const {
  ADD_DEFAULT_FLEET_SALES,
  GET_FLEET_SALES,
  GET_TOTAL_FLEET_SALES,
  GET_FLEET,
  GET_SKU,
  SAVE_SALE,
  GET_FLEET_SALES_REPORT,
  GET_FLEET_SALES_TOTAL_REPORT,
  GET_TARGET_SALES,
  UPDATE_TARGET_SALES,
  GET_ZONAL_FLEET_MANAGER_SALES_REPORT,
  DELETE_SALES,
  EDIT_SALES,
  GET_SALES
} = routes.SALES_REPORT;

const API_URL = process.env.VITE_APP_API_URL;

export default class SalesReportService {
  /**
   * @name addDefautFleetSales
   * @description Add Defaut Fleet Sales
   * @param {obj: Object}
   * @method POST
   * @returns promise
   */
  static addDefautFleetSales(obj) {
    return request(
      "POST",
      `${API_URL}${ADD_DEFAULT_FLEET_SALES}`,
      null,
      obj,
      null
    );
  }

  /**
   * @name saveSale
   * @description Save Sale
   * @param {obj: Object}
   * @method POST
   * @returns promise
   */
  static saveSale(obj) {
    return request("POST", `${API_URL}${SAVE_SALE}`, null, obj, null);
  }

  /**
   * @name getFleetSalesFM
   * @description Get Defaut Fleet Sales FM
   * @param {obj: Object}
   * @method POST
   * @returns promise
   */
  static getFleetSalesFM(obj) {
    let qp = "?";
    if (obj.month) {
      qp += `m=${obj.month}&`;
    }
    if (obj.year) {
      qp += `y=${obj.year}&`;
    }
    if (obj.page) {
      qp += `page=${obj.page}&`;
    }
    if (obj.pagesize) {
      qp += `pagesize=${obj.pagesize}&`;
    }
    if (obj.downloadReport) {
      qp += `download_report=${obj.downloadReport}&`;
    }
    if (obj.search) {
      qp += `q=${obj.search}&`;
    }

    return request(
      "GET",
      `${API_URL}${GET_FLEET_SALES}${qp}`,
      null,
      null,
      null
    );
  }

  /**
   * @name getTotalFleetSalesFM
   * @description Get Total Fleet Sales FM
   * @param {obj: Object}
   * @method GET
   * @returns promise
   */
  static getTotalFleetSalesFM(obj) {
    return request(
      "GET",
      `${API_URL}${GET_TOTAL_FLEET_SALES}?m=${obj.month}&y=${obj.year}`,
      null,
      null,
      null
    );
  }

  /**
   * @name getFleets
   * @description Get Fleet
   * @param {}
   * @method GET
   * @returns promise
   */
  static getFleets() {
    return request("GET", `${API_URL}${GET_FLEET}`, null, null, null);
  }

  /**
   * @name getSKU
   * @description Get SKU
   * @param {}
   * @method GET
   * @returns promise
   */
  static getSKU(type) {
    return request(
      "GET",
      `${API_URL}${GET_SKU}?type=${type}`,
      null,
      null,
      null
    );
  }

  /**
   * @name getFleetSalesReport
   * @description getFleetSalesReport
   * @param {obj: Object}
   * @method GET
   * @returns promise
   */
  static getFleetSalesReportZFM(obj) {
    return request(
      "GET",
      `${API_URL}${GET_FLEET_SALES_REPORT}?m=${obj.month}&y=${obj.year}&page=${obj.page}&pagesize=${obj.pagesize}&fleet_id=${obj.uuid}&download_report=${obj.downloadReport}`,
      null,
      null,
      null
    );
  }

  /**
   * @name getFleetSalesTotalReport
   * @description getFleetSalesTotalReport
   * @param {obj: Object}
   * @method GET
   * @returns promise
   */
  static getFleetSalesTotalReportZFM(obj) {
    return request(
      "GET",
      `${API_URL}${GET_FLEET_SALES_TOTAL_REPORT}?m=${obj.month}&y=${obj.year}&fleet_id=${obj.uuid}`,
      null,
      null,
      null
    );
  }

  static getSalesReportZFM(month, year, downloadReport, zone) {
    let qp = "";
    if (month) {
      qp = `?m=${month}`;
    }
    if (year) {
      qp = `${qp}&y=${year}`;
    }
    if (zone) {
      qp = `${qp}&zone=${zone}`;
    }
    if (downloadReport) {
      qp = `${qp}&download_report=${downloadReport}`;
    }
    return request(
      "GET",
      `${API_URL}${GET_ZONAL_FLEET_MANAGER_SALES_REPORT}${qp}`,
      null,
      null,
      null
    );
  }

  static getTargetSales(month, year, search, downloadReport) {
    let qp = "";
    if (month) {
      qp = `?m=${month}`;
    }
    if (year) {
      qp = `${qp}&y=${year}`;
    }
    if (search) {
      qp = `${qp}&q=${search}`;
    }
    if (downloadReport) {
      qp = `${qp}&download_report=${downloadReport}`;
    }
    return request(
      "GET",
      `${API_URL}${GET_TARGET_SALES}${qp}`,
      null,
      null,
      null
    );
  }

  static updateTargetSales(obj) {
    return request("POST", `${API_URL}${UPDATE_TARGET_SALES}`, null, obj, null);
  }

  /**
   * @name deleteSales
   * @description Delete sales
   * @param {obj: Object}
   * @method POST
   * @returns promise
   */
  static deleteSales(obj) {
    return request("POST", `${API_URL}${DELETE_SALES}`, null, obj, null);
  }

  static editSales(obj) {
    return request("POST", `${API_URL}${EDIT_SALES}`, null, obj, null);
  }

  static getSales(id) {
    let qp = "";
    if (id) {
      qp = `?id=${id}`;
    } else {
      return Promise.reject(null);
    }
    return request("GET", `${API_URL}${GET_SALES}${qp}`, null, null, null);
  }
}
